import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { DatePipe } from '@angular/common';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx'
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import * as CryptoJS from 'crypto-js';
import { CommonService } from 'src/providers/common';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { HttpClient } from '@angular/common/http';
import { FileOpener } from '@ionic-native/file-opener/ngx';

@Component({
  selector: 'app-report',
  templateUrl: './report.page.html',
  styleUrls: ['./report.page.scss'],
})
export class ReportPage implements OnInit {

  presentView: any;
  prescriptionHistory = [];
  EmtyData: any;
  ReportList: any = [];
  nameSorting: boolean;
  nameBasedSortingOrder: any = null;
  dateSorting: boolean;
  dateBasedSortingOrder: any = null;
  LabTestDetails: any;
  nextCount: any;
  pageno1: any;
  partReportList = [];
  backValue: string;
  headerValue: any;
  crntPatientId: string;
  crntPatientName: any;
  getplatform: string;
  dynClass: string;
  addImg: any;
  tymVal: any;
  refEvent: any;
  scrollEvent: any; segvalue: any;
  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    zoom: 'yes',
    hideurlbar: 'yes',
  };
  decryptionKey: any;
  url_data: any;
  isReportModalOpen: boolean = false;
  changeheader: any = "dochead";
  Member_details: any = [];
  Family_Member_details: any = [];
  isReportDate: boolean;
  selectedCardSegment: number;
  presentView_Report: any;
  Clinic_Report_Count: any;
  Lab_Report_Count: any;
  Prescription_Report_Count: any;
  prescriptionHistory_Data: any = [];
  defaultImage = 'assets/img/Vector.png';
  MaleImage = 'assets/newIcons/MaleJpg.jpg';
  FemaleImage = 'assets/newIcons/FeMaleJpg.jpg';

  constructor(
    public router: Router,
    public socialSharing: SocialSharing,
    private services: ServicesProvider,
    private datePipe: DatePipe,
    private transfer: FileTransfer,
    public file: File,
    public platform: Platform,
    public modalCtrl: ModalController,
    public addCall: AddCall,
    private inAppBrowser: InAppBrowser,
    public popoverCtrl: PopoverController,
    public http: HttpClient,
    private fileOpener: FileOpener,
  ) { }
  private common = CommonService;


  ngOnInit() {
    this.platform.ready().then(() => {
      if (this.platform.is("desktop")) {
        this.getplatform = "desktop";
      } else if (this.platform.is("ios")) {
        this.getplatform = "ios";
      } else if (this.platform.is("android")) {
        this.getplatform = "android";
      }
    });

    this.decryptionKey = "OneMomentLabDicomService";
    this.url_data = ""
    this.isReportModalOpen = false;
    this.isReportDate = false;
  }

  doRefresh(event) {
    this.refEvent = event;
    this.particularReport(this.crntPatientId);
  }
  refFunc() {
    if (this.refEvent) {
      this.refEvent.target.complete();
    }
  }
  infyFunc() {
    if (this.scrollEvent) {
      this.scrollEvent.target.complete();
    }
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    if (this.addCall.selectedLanguage == 'en') {


      let Value;
      switch (callFor) {
        case "Time":
          if (dateTime.indexOf("T") > -1) {
            Value = dateTime.split("T")[1];
          } else if (dateTime.indexOf(" ") > -1) {
            Value = dateTime.split(" ")[1];
          } else {
            Value = dateTime;
          }
          let hourEnd = Value.indexOf(":");
          let H = +String(Value).substr(0, hourEnd);
          let h = H % 12 || 12;
          let ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
          let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
          return timeString;
        case "Date":
          return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
        case "DateTime":
          return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
        case "Date1":
          if (this.addCall.selectedLanguage == 'en') {
            return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy")
          } else {
            let dateCall = new Date(dateTime);
            let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
              "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
            ];
            let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
            return arDate;
          }
      }
    } else {
      let dateCall = new Date(dateTime);
      let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
        "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
      ];
      let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
      return arDate;
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  onImageErrors(event: Event,value:any): void {
    if(value == 'Male'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.MaleImage;
    }else if(value == 'Female'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.FemaleImage;
    }
    else if(value == 'Vector'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.defaultImage;
    }
  }

  downloadReport(link, id) {
    let setname = "img" + id;
    console.log("imgName=>", setname);
    if (this.getplatform == "ios") {
      console.log("android Directory=>", this.file.documentsDirectory);
      console.log("download file path>", link);
      const fileDownload: FileTransferObject = this.transfer.create();
      let url = encodeURI(link);
      fileDownload.download(url, this.file.documentsDirectory + setname).then((entry) => {
        console.log('download complete: ' + entry.toURL());
      }, (error) => {
        console.log(error,"error");
      });
    }
    else if (this.getplatform == "android") {
      console.log("android Directory=>", this.file.dataDirectory);
      console.log("download file path>", link);
      const fileDownload: FileTransferObject = this.transfer.create();
      const url = encodeURI(link);
      fileDownload.download(url, this.file.dataDirectory + setname).then((entry) => {
        alert('download complete: ' + entry.toURL());
      }, (error) => {
        console.log(error,"error");
      });
    }
  }

  ionViewWillEnter() {
    this.changeheader = "dochead";
    this.common.videoSound = false;
    this.common.setDoctorDetails(false);
    this.isReportModalOpen = false;
    console.log(this.common.videoSound, "VideoSound");
    this.Member_details = [];
    this.Family_Member_details = [];
    this.prescriptionHistory = []
    this.getPatientBasicDetails();
    this.tymVal = window.localStorage['RepADD'];
    let CD = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0];
    console.log("tymVal -> ", this.tymVal, "\nCD     -> ", CD);
    this.nameSorting = false;
    this.dateSorting = true;
    this.EmtyData = null;
    this.ReportList = [];
    this.labResultMembersList();
    this.presentView = "medicalReports";
    this.selectedCardSegment = 1;
    this.segvalue = "prescription";
    this.presentView_Report = 'Prescription_Report';
    this.backValue = "goHome";
    this.headerValue = this.addCall.title318;
  }


  openPersonDet(patientId, patientName) {
    debugger;
    this.Prescription_Report_Count = 0;
    this.Lab_Report_Count = 0;
    this.Clinic_Report_Count = 0;
    this.isReportDate = false;
    this.changeheader = "dochead";
    this.crntPatientId = patientId;
    this.crntPatientName = patientName;
    this.nameBasedSortingOrder = "ASC";
    this.dateBasedSortingOrder = "DESC";
    this.presentView = "personDetails";
    this.backValue = "goReportPage";
    this.selectedCardSegment = 1;
    this.segvalue = 'prescription';
    this.presentView_Report = 'Prescription_Report';
    this.headerValue = patientName + ' ' + this.addCall.title318;
    console.log("Member Name=>", this.headerValue);
    this.particularReport(this.crntPatientId);
  }

  showclinicdetails: any;
  prescriptiondet: any;
  openPersonDetailsView(index, frm) {
    debugger;
    console.log(frm, 'frm');

    if (frm == 'lab') {
      this.LabTestDetails = this.partReportList[index];
      this.ReportViewStatus(2,this.LabTestDetails.bookingid);
      this.segvalue = 'lab';
      if (this.LabTestDetails.lab_test_file_name && this.LabTestDetails.lab_test_file_name != "") {
        if (this.platform.is("ios")) {
          console.log("ios")
          const urlRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;
          const decryptedText = urlRegex.test(this.LabTestDetails.lab_test_file_name) ? this.LabTestDetails.lab_test_file_name : this.decrypt(this.LabTestDetails.lab_test_file_name);
          const validExtensions = [".png", ".jpeg", ".jpg"];
          const isFileValid = validExtensions.some(extension => decryptedText.includes(extension));
          if (isFileValid) {
            if (decryptedText.includes(".pdf")) {
              this.inAppBrowser.create(`https://docs.google.com/gview?embedded=true&url=${decryptedText}&t=${new Date().getTime()}&s=${new Date().getMilliseconds()}`, "_blank", this.options)
            }
            else {
              this.headerValue = this.addCall.title702;
              this.backValue = "goPrsnDtlPage";
              this.isReportDate = false;
              this.isReportModalOpen = true
              this.url_data = decryptedText
            }
          }
          else {
            this.inAppBrowser.create(decryptedText, "_blank", this.options)
          }
        } else if (this.platform.is("android")) {
          console.log("android")
          const urlRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;
          const decryptedText = urlRegex.test(this.LabTestDetails.lab_test_file_name) ? this.LabTestDetails.lab_test_file_name : this.decrypt(this.LabTestDetails.lab_test_file_name);
          const validExtensions = [".pdf", ".png", ".jpeg", ".jpg"];
          const isFileValid = validExtensions.some(extension => decryptedText.includes(extension));
          if (isFileValid) {
            if (decryptedText.includes(".pdf")) {
              const url = this.LabTestDetails.lab_test_file_name;
              const fileName = `contract_${new Date().getTime()}.pdf`;
              const filePath = this.file.dataDirectory + fileName;
      
              this.http.get(url, { responseType: 'blob' }).subscribe(
            (blob) => {
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                const arrayBuffer = fileReader.result as ArrayBuffer;
                const uint8Array = new Uint8Array(arrayBuffer);
                this.file.writeFile(this.file.dataDirectory, fileName, blob, { replace: true }).then(() => {
                    this.fileOpener.open(filePath, 'application/pdf').then(() => 
                      console.log('File opened successfully'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(err => console.error('File write failed', err));
              };
              fileReader.readAsArrayBuffer(blob);
            },
            (error) => console.error('Download failed', error)
              );
             }
             else {
              this.headerValue = this.addCall.title702;
              this.backValue = "goPrsnDtlPage";
              this.isReportDate = false;
              this.isReportModalOpen = true
              this.url_data = decryptedText
             }
          }
        }
      }
    }
    else if (frm == 'clinic') {
      this.showclinicdetails = this.ClinicReport[index];
      this.ReportViewStatus(3,this.showclinicdetails.id);
      this.segvalue = 'clinic';
      if (this.showclinicdetails.report_filepath && this.showclinicdetails.report_filepath != "") {
        if (this.platform.is("ios")) {
          console.log("ios")
          const urlRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;
          const decryptedText = urlRegex.test(this.showclinicdetails.report_filepath) ? this.showclinicdetails.report_filepath : this.decrypt(this.showclinicdetails.report_filepath);
          const validExtensions = [".png", ".jpeg", ".jpg"];
          const isFileValid = validExtensions.some(extension => decryptedText.includes(extension));
          if (isFileValid) {
            if (decryptedText.includes(".pdf")) {
              this.inAppBrowser.create(`https://docs.google.com/gview?embedded=true&url=${decryptedText}&t=${new Date().getTime()}&s=${new Date().getMilliseconds()}`, "_blank", this.options)
            }
            else {
              this.headerValue = this.addCall.title39;
              this.backValue = "goPrsnDtlPage";
              this.isReportDate = false;
              this.isReportModalOpen = true
              this.url_data = decryptedText
            }
          }
          else {
            this.inAppBrowser.create(decryptedText, "_blank", this.options)
          }
        } else if (this.platform.is("android")) {
          console.log("android");
          const urlRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;
          const decryptedText = urlRegex.test(this.showclinicdetails.report_filepath) ? this.showclinicdetails.report_filepath : this.decrypt(this.showclinicdetails.report_filepath);
          const validExtensions = [".pdf", ".png", ".jpeg", ".jpg"];
          const isFileValid = validExtensions.some(extension => decryptedText.includes(extension));
          if (isFileValid) {
            if (decryptedText.includes(".pdf")) {
              const url = this.showclinicdetails.report_filepath;
              const fileName = `contract_${new Date().getTime()}.pdf`;
              const filePath = this.file.dataDirectory + fileName;
      
              this.http.get(url, { responseType: 'blob' }).subscribe(
            (blob) => {
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                const arrayBuffer = fileReader.result as ArrayBuffer;
                const uint8Array = new Uint8Array(arrayBuffer);
                this.file.writeFile(this.file.dataDirectory, fileName, blob, { replace: true }).then(() => {
                    this.fileOpener.open(filePath, 'application/pdf').then(() => 
                      console.log('File opened successfully'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(err => console.error('File write failed', err));
              };
              fileReader.readAsArrayBuffer(blob);
            },
            (error) => console.error('Download failed', error)
              );
             }
             else {
              this.headerValue = this.addCall.title39;
              this.backValue = "goPrsnDtlPage";
              this.isReportDate = false;
              this.isReportModalOpen = true
              this.url_data = decryptedText
             }
          }
        }
      }

    }
    else if (frm == "prescription") {
      console.log(this.prescriptionHistory[index]);
      this.prescriptiondet = this.prescriptionHistory[index];
      this.ReportViewStatus(9,this.prescriptiondet.orderId);
      this.segvalue = 'prescription';
      if (this.prescriptiondet.prescript_file_path && this.prescriptiondet.prescript_file_path != "") {
        if (this.platform.is("ios")) {
          console.log("ios")
          const urlRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;
          const decryptedText = urlRegex.test(this.prescriptiondet.prescript_file_path) ? this.prescriptiondet.prescript_file_path : this.decrypt(this.prescriptiondet.prescript_file_path);
          const validExtensions = [".png", ".jpeg", ".jpg"];
          const isFileValid = validExtensions.some(extension => decryptedText.includes(extension));
          if (isFileValid) {
            if (decryptedText.includes(".pdf")) {
              this.inAppBrowser.create(`https://docs.google.com/gview?embedded=true&url=${decryptedText}&t=${new Date().getTime()}&s=${new Date().getMilliseconds()}`, "_blank", this.options)
            }
            else {
              this.headerValue = this.addCall.title203;
              this.backValue = "goPrsnDtlPage";
              this.isReportModalOpen = true;
              this.url_data = decryptedText;
            }
          }
          else {
            this.inAppBrowser.create(decryptedText, "_blank", this.options)
          }
        } else if (this.platform.is("android")) {
          console.log("android")
          const urlRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;
          const decryptedText = urlRegex.test(this.prescriptiondet.prescript_file_path) ? this.prescriptiondet.prescript_file_path : this.decrypt(this.prescriptiondet.prescript_file_path);
          const validExtensions = [".png", ".jpeg", ".jpg"];
          const isFileValid = validExtensions.some(extension => decryptedText.includes(extension));
          if (isFileValid) {
            if (decryptedText.includes(".pdf")) {
              this.inAppBrowser.create(`https://docs.google.com/gview?embedded=true&url=${decryptedText}&t=${new Date().getTime()}&s=${new Date().getMilliseconds()}`, "_blank", this.options)
            }
            else {
              this.headerValue = this.addCall.title203;
              this.backValue = "goPrsnDtlPage";
              this.isReportModalOpen = true;
              this.url_data = decryptedText;
            }
          }
          else {
            this.inAppBrowser.create(decryptedText, "_blank", this.options)
          }
        }
      }
    }
  }

  isReportModalOpenClose() {
    debugger;
    if (this.segvalue == 'lab') {
      this.isReportDate = true;
    } else if (this.segvalue == 'clinic') {
      this.isReportDate = false;
    } else if (this.segvalue == 'prescription') {
      this.isReportDate = false;
    }
    this.presentView = "personDetails";
    this.isReportModalOpen = false;
    this.backValue = "goReportPage";
  }

  decrypt(encryptedData: string) {
    const parts = encryptedData.split(":");
    const iv = CryptoJS.enc.Hex.parse(parts[0]);
    const encrypted = CryptoJS.enc.Hex.parse(parts[1]);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encrypted, iv: iv } as CryptoJS.lib.CipherParams,
      CryptoJS.enc.Utf8.parse(this.decryptionKey),
      { mode: CryptoJS.mode.CTR, padding: CryptoJS.pad.NoPadding }
    ).toString(CryptoJS.enc.Utf8);

    return decrypted;
  }

  testSort() {
    this.nameSorting = true;
    this.dateSorting = false;
    if (this.nameBasedSortingOrder == "ASC") {
      this.nameBasedSortingOrder = "DESC";
    } else if (this.nameBasedSortingOrder == "DESC") {
      this.nameBasedSortingOrder = "ASC";
    }
    this.particularReport(this.crntPatientId);
    console.log("Name Sorting => ", this.nameBasedSortingOrder);
  }

  dateSort() {
    this.dateSorting = true;
    this.nameSorting = false;
    if (this.dateBasedSortingOrder == "ASC") {
      this.dateBasedSortingOrder = "DESC";
    } else if (this.dateBasedSortingOrder == "DESC") {
      this.dateBasedSortingOrder = "ASC";
    }
    this.particularReport(this.crntPatientId);
    console.log("Date Sorting => ", this.dateBasedSortingOrder);
  }


  particularReport(patientId) {
    this.pageno1 = 1;
    this.EmtyData = null;
    this.partReportList = [];
    this.prescriptionHistory = [];
    this.ClinicReport = [];

    this.particularMemberLabResults(this.crntPatientId);
    this.get_Clinicreport(this.crntPatientId);
    this.getPrescHis(this.crntPatientId);
  }

  loadData1(event) {
    debugger;
    this.scrollEvent = event;
    this.pageno1 += 1;
    console.log(this.nextCount);

    if (this.nextCount != 0) {
      if (this.segvalue == 'lab') {
        this.particularMemberLabResults(this.crntPatientId)
      } else if (this.segvalue == 'clinic') {
        this.get_Clinicreport(this.crntPatientId)
      } else if (this.segvalue == 'prescription') {
        console.log('prescription');
        this.getPrescHis(this.crntPatientId);
      }
    }
  }

  Sharing(test, link) {
    console.log("Test -> ", test);
    console.log("Link -> ", link);
    try {
      this.socialSharing.share(String(test) + " \n", String(test) + " Report", null, String(link));
    } catch (e) {
      console.log(e)
    }
  }


  labResultMembersList() {
    try {
      this.EmtyData = null;
      let requestdata = JSON.stringify({
        "patientId": localStorage.getItem('patient_id')
      });
      console.log("Report Page => ", requestdata);
      this.services.postRequest("labResultMembersList", requestdata).subscribe(response => {
        console.log("details=>", response);
        this.EmtyData = response.status;
        if (response.data.length > 0) {
          this.ReportList = response.data[0];
        } else {
          this.ReportList = [];
        }
      }, err => {
        console.log(err);
      });
    } catch (err) {
      console.log(err);
    }
  }

  particularMemberLabResults(patientId) {

    this.nextCount = 0;
    try {
      let requestdata = JSON.stringify({
        "patientId": patientId != "" && patientId != undefined ? patientId : localStorage.getItem('patient_id'),
        "nameBasedSorting": this.nameSorting,
        "nameBasedSortingOrder": this.nameBasedSortingOrder,
        "dateBasedSorting": this.dateSorting,
        "dateBasedSortingOrder": this.dateBasedSortingOrder,
        "limit": 10,
        "pageno": this.pageno1
      });
      this.services.postRequest("particularMemberLabResults", requestdata).subscribe(response => {
        console.log(response);
        this.EmtyData = response.status;
        debugger;
        if (this.pageno1 == 1) {
          this.partReportList = [];
        }
        if (response.data.length > 0) {
          for (let item of response.data[0].details) {
            this.partReportList.push(item);
          }
          this.nextCount = response.data[0].nextCount;
          this.Lab_Report_Count = response.data[0].totalCount;
        }
        if (this.scrollEvent) {
          this.scrollEvent.target.disabled = this.nextCount == 0 ? true : false;
        }
        this.segvalue = 'lab';
        this.refFunc();
        this.infyFunc();
      }, err => {
        console.log(err);
        this.refFunc();
        this.infyFunc();
      });
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  openUp() {
    this.router.navigate(['/upload-report']);
  }

  ClinicReport: any;
  segmentChanged(event) {
    debugger;
    this.nextCount = 0;
    this.segvalue = event;
    console.log(this.segvalue,"segevent");
    this.pageno1 = 1;
    if (this.segvalue == 'lab') {
      this.selectedCardSegment = 2;
      this.presentView_Report = 'Lab_Report';
      this.isReportDate = true;
      this.partReportList = [];
      this.segvalue = 'lab';
      this.particularMemberLabResults(this.crntPatientId);
    } else if (this.segvalue == 'clinic') {
      this.selectedCardSegment = 3;
      this.presentView_Report = 'Clinic_Report';
      this.isReportDate = false;
      this.ClinicReport = [];
      this.segvalue = 'clinic';
      this.get_Clinicreport(this.crntPatientId);
    } else if (this.segvalue == 'prescription') {
      this.selectedCardSegment = 1;
      this.presentView_Report = 'Prescription_Report';
      this.isReportDate = false;
      console.log('prescription');
      this.prescriptionHistory = [];
      this.segvalue = 'prescription';
      this.getPrescHis(this.crntPatientId);
    }
  }



  get_Clinicreport(patientId) {
    let requestdata = JSON.stringify({
      "patientId": patientId,
      "doctorId": '',
      "clinicId": '',
      "frmreq": "Member",
      "dateBasedSorting": this.dateSorting,
      "dateBasedSortingOrder": this.dateBasedSortingOrder,
      "limit": 10,
      "pageno": this.pageno1
    });
    this.services.ClinicData('getReportsByClinic', requestdata).subscribe((data) => {
      console.log(data)
      this.EmtyData = data.data;
      debugger;
      if (this.pageno1 == 1) {
        this.ClinicReport = [];
      }
      if (data.data.length > 0) {
        for (let item of data.data[0].details) {
          this.ClinicReport.push(item);
        }
        this.nextCount = data.data[0].nextCount;
        this.Clinic_Report_Count = data.data[0].totalCount;
      }
      if (this.scrollEvent) {
        this.scrollEvent.target.disabled = this.nextCount == 0 ? true : false;
      }
      this.segvalue = 'clinic';
      this.refFunc();
      this.infyFunc();
    })

  }


  getPrescHis(patientId) {
    try {
      this.prescriptionHistory_Data = [];
      this.nextCount = 0;
      if (this.pageno1 == 1) {
        this.EmtyData = null;
      }
      let requestdata = JSON.stringify({
        "patientId": patientId,
        "filter": "",
        "statusIdList": "",
        "filterFromDate": "",
        "filterToDate": "",
        "dateBasedSorting": this.dateSorting,
        "dateBasedSortingOrder": this.dateBasedSortingOrder,
        "limit": 10,
        "pageno": this.pageno1,
        "status": 2
      });
      this.services.postRequest("patientPrescriptionHistoryDetails", requestdata).subscribe(response => {
        console.log(response);
        debugger;
        if (this.pageno1 == 1) {

          this.prescriptionHistory = [];
        }
        if (this.pageno1 != 1 && response.data.length != 0) {
          for (let item of response.data[0].details) {
            this.prescriptionHistory.push(item);
            console.log('=======', response.data[0].nextCount);
            if(item.orderStatusId != 4){
               this.prescriptionHistory_Data.push(item);
            }
          }
          this.nextCount = response.data[0].nextCount;
          this.Prescription_Report_Count = response.data[0].totalCount;
        } else if (this.pageno1 == 1 && response.data.length != 0) {
          console.log('=======', response.data[0].nextCount);
          this.EmtyData = response.status;
          this.nextCount = response.data[0].nextCount;
          this.Prescription_Report_Count = response.data[0].totalCount;
          for (let item of response.data[0].details) {
            this.prescriptionHistory.push(item);
            if(item.orderStatusId != 4){
               this.prescriptionHistory_Data.push(item);
            }
          }

        }
        else {
          this.EmtyData = response.status;
          this.prescriptionHistory = [];
          this.nextCount = 0;
        }
        this.segvalue = 'prescription';
        this.refFunc();
        this.infyFunc();
      }, err => {
        console.log(err);
        this.refFunc();
        this.infyFunc();
      });
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }


  goBack(value) {
    debugger;
    switch (value) {
      case 'goHome': {
        this.router.navigate(['/tabs/home']);
        break;
      }
      case 'goReportPage': {
        this.presentView = "medicalReports";
        this.backValue = "goHome";
        this.headerValue = this.addCall.title318;
        break;
      }
      case 'goPrsnDtlPage': {
        if (this.segvalue == 'lab') {
          this.particularMemberLabResults(this.crntPatientId);
          this.isReportDate = true;
        } else if (this.segvalue == 'clinic') {
          this.get_Clinicreport(this.crntPatientId);
          this.isReportDate = false;
        } else if (this.segvalue == 'prescription') {
          this.getPrescHis(this.crntPatientId);
          this.isReportDate = false;
        }
        this.presentView = "personDetails";
        this.backValue = "goReportPage";
        this.headerValue = this.crntPatientName + " " + this.addCall.title318;
        this.isReportModalOpen = false
        break;
      }
    }
  }


  getPatientBasicDetails() {

    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });
    console.log("send patient Basic Details Reqst=>", JSON.parse(apiData));
    this.services.postRequest("getPatientProfile", apiData).subscribe(res => {
      console.log(res);
      debugger;
      if (res.msg == "Success") {
        this.Member_details.push(res.data[0])
        for (let i = 0; i < res.data[0].patientmemberDetails?.length; i++) {
          this.Family_Member_details.push(res.data[0].patientmemberDetails[i]);
        }
      }
    });
  }

  async openPopovr1(event: any) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: event,
      translucent: true,
      componentProps: {
        from: 'report',
        reportdata: this.addCall.title703,
      },
      cssClass: 'offrMod3',
    });
    return await popover.present();
  }


  ReportViewStatus(moduleId,ReportId) {
   debugger;
    try {
      let requestdata = JSON.stringify({
        "moduleId": moduleId,
        "reportBookingId": ReportId,
        "reportViewStatus": 1,
      });
      this.services.postRequest("patientReportView", requestdata).subscribe(response => {
        debugger;
        console.log(response,"Report_View");
      }, err => {
        console.log(err);
      });
    } catch (err) {
      console.log(err);
    }
  }
}
